import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22theme.js%22,%22import%22:%22Fira_Code%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22display%22:%22swap%22,%22preload%22:false,%22fallback%22:[%22ui-monospace%22,%22SFMono-Regular%22,%22Menlo%22,%22Consolas%22,%22Liberation%20Mono%22,%22DejaVu%20Sans%20Mono%22,%22Courier%20New%22,%22monospace%22]}],%22variableName%22:%22FIRA_CODE%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Fira Code', ui-monospace, SFMono-Regular, Menlo, Consolas, Liberation Mono, DejaVu Sans Mono, Courier New, monospace",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
